import React, { useContext, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga4'
import Table from '@components/table'
import Avatar from '@components/avatar'
import IconFilterFields from '@components/table/IconFilterFields'

import { WindowContext } from '@components/windowContextProvider'

import {
  HeaderContainer,
  Text,
  Button,
  DataContainer,
  NameContainer,
} from './styles'

const CompaniesList = ({
  filterState,
  setFilterState,
  companies,
  goToCompany,
}) => {
  const { clientWidth } = useContext(WindowContext)
  const [orderByWithCollection, setOrderByWithCollection] = useState('')
  const [orderByActive, setOrderByActive] = useState('')

  const setOrderBy = (field) => {
    if (!filterState[field]) {
      setFilterState({ ...filterState, [field]: 'desc' })
    } else if (filterState[field] === 'desc') {
      setFilterState({ ...filterState, [field]: 'asc' })
    } else {
      setFilterState({ ...filterState, [field]: null })
    }
  }
  const setOrderByState = () => {
    if (!orderByWithCollection) {
      setOrderByWithCollection('desc')
    } else if (orderByWithCollection === 'desc') {
      setOrderByWithCollection('asc')
    } else {
      setOrderByWithCollection('')
    }
  }
  const setOrderByActiveState = () => {
    if (!orderByActive) {
      setOrderByActive('desc')
    } else if (orderByActive === 'desc') {
      setOrderByActive('asc')
    } else {
      setOrderByActive('')
    }
  }

  const orderCompany = (list) => {
    if (!Array.isArray(list)) return []
    let sorted = [...list]

    if (filterState.orderByBeneficiaryNumber) {
      sorted = sorted.sort((a, b) => (filterState.orderByBeneficiaryNumber === 'asc'
        ? a.totalBeneficiaries - b.totalBeneficiaries
        : b.totalBeneficiaries - a.totalBeneficiaries))
    }
    if (orderByActive) {
      sorted = sorted.sort((a, b) => (orderByActive === 'asc'
        ? a.totalBeneficiariesActive - b.totalBeneficiariesActive
        : b.totalBeneficiariesActive - a.totalBeneficiariesActive))
    }
    if (orderByWithCollection) {
      sorted = sorted.sort((a, b) => (orderByWithCollection === 'asc'
        ? a.totalBeneficiariesWithCollection
            - b.totalBeneficiariesWithCollection
        : b.totalBeneficiariesWithCollection
            - a.totalBeneficiariesWithCollection))
    }
    return sorted
  }

  const removeTableItemOnWidth = (arr) => {
    if (clientWidth <= 980) arr.splice(1, 1)
    if (clientWidth <= 800) arr.splice(3, 1)
    if (clientWidth <= 700) arr.splice(1, 1)
    if (clientWidth <= 560) arr.splice(1, 1)
  }

  const dataHeads = [
    <HeaderContainer onClick={() => setOrderBy('orderByName')}>
      <IconFilterFields orderBy={filterState.orderByName} />
      Empresa
    </HeaderContainer>,
    <HeaderContainer>CNPJ</HeaderContainer>,
    <HeaderContainer onClick={() => setOrderBy('orderByBeneficiaryNumber')}>
      <IconFilterFields orderBy={filterState.orderByBeneficiaryNumber} />
      TOTAL DE BENEFICIÁRIOS
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderByActiveState()}>
      <IconFilterFields orderBy={orderByActive} />
      BENEFICIÁRIOS ATIVOS
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderByState()}>
      <IconFilterFields orderBy={orderByWithCollection} />
      BENEFICIÁRIOS PARTICIPANTES
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderBy('orderByLastCollectionDay')}>
      <IconFilterFields orderBy={filterState.orderByLastCollectionDay} />
      ÚLTIMA COLETA
    </HeaderContainer>,
    'DETALHES',
  ]
  removeTableItemOnWidth(dataHeads)

  const data = _.map(orderCompany(companies), (company) => {
    const {
      name,
      cnpj,
      totalBeneficiaries,
      totalBeneficiariesActive,
      totalBeneficiariesWithCollection,
      lastCollectionDay,
    } = company

    const row = [
      <DataContainer>
        <NameContainer>
          <Avatar name={name} />
          <Text style={{ paddingLeft: 16 }}>{name}</Text>
        </NameContainer>
      </DataContainer>,
      <DataContainer>
        <Text>{cnpj}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{totalBeneficiaries}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{totalBeneficiariesActive}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{totalBeneficiariesWithCollection}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{lastCollectionDay}</Text>
      </DataContainer>,
      <DataContainer>
        <Button
          onClick={() => {
            goToCompany(company)
            ReactGA.event({
              category: 'Acessar empresa',
              action: 'Clique em Acessar empresa',
              label: 'Botão de acessar empresa',
            })
          }}
        >
          Acessar
        </Button>
      </DataContainer>,
    ]
    removeTableItemOnWidth(row)
    return row
  })

  return (
    <Table
      headline
      dataHeads={dataHeads}
      data={data}
      dataWidth={[
        '20%',
        '10%',
        '16%',
        '16%',
        '14%',
        '14%',
        '12%',
      ]}
    />
  )
}

CompaniesList.propTypes = {
  filterState: PropTypes.object.isRequired,
  setFilterState: PropTypes.func.isRequired,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      cnpj: PropTypes.string,
      totalBeneficiaries: PropTypes.number,
      totalBeneficiariesActive: PropTypes.number,
      totalBeneficiariesWithCollection: PropTypes.number,
      lastCollectionDay: PropTypes.string,
    })
  ),
  goToCompany: PropTypes.func.isRequired,
}

CompaniesList.defaultProps = {
  companies: null,
}

export default CompaniesList
